module.exports = __webpack_public_path__ + "static/media/crossLight.3406886c.svg";